import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import Dialog from './Dialog/Dialog';
import Icons from '../Icons/Icons';

function Figure({ className, mediaContainerClassName, mediaType = "image", medias, hasCreditsPopin, credits, hasCaption, caption, mediaAlt }) {
    let outerContainerClasses = `${className} quiz-figure`;
    let mediaContainerClasses = (mediaContainerClassName) ? `${mediaContainerClassName} quiz-figure__media-container quiz-figure__media-container--subgrid` : "quiz-figure__media-container";

    // On créé l'états autour de la popin
    const [ isPopinOpen, setIsPopinOpen ] = useState(false);

    // On créé l'état pour la vidéo
    const [ isPlaying, setIsPlaying ] = useState(true);

    // On créé la référence de la vidéo
    const videoRef = useRef(null);

    // On met en place le useEffect pour la vidéo avec le switch entre le Play / Pause
    useEffect(() => {
        if(!videoRef.current) return;
        const video = videoRef.current;

        if(isPlaying) {
            video.play();
        } else {
            video.pause();
        }
    }, [isPlaying]);

    // Montage du contenu en fonction de mediaType
    let content;
    if(mediaType === 'image') {
        content =
            <figure className={outerContainerClasses}>
                <div className={mediaContainerClasses}>
                    <picture className="quiz-figure__media-picture">
                        <source srcSet={medias.desktop} media="(min-width: 600px)" />
                        <img src={medias.mobile} alt={mediaAlt || ''} />
                    </picture>
                    {hasCreditsPopin && (
                        <>
                            <button className="button button--legend" aria-label="afficher la légende de l'image" onClick={() => setIsPopinOpen(true)}>
                                <svg role="img" xmlns="http://www.w3.org/2000/svg" width="32" height="32" version="1.1" viewBox="0 0 32 32">
                                    <title>afficher la légende de l&apos;image</title>
                                    <circle cx="16" cy="16" r="15.12" />
                                    <path d="M17.26,10.37c0,.7-.53,1.22-1.27,1.22s-1.25-.51-1.25-1.22.55-1.18,1.25-1.18,1.27.49,1.27,1.18ZM15.03,13.39h1.93v9.42h-1.93s0-9.42,0-9.42Z"/>
                                </svg>
                            </button>
                            <Dialog
                                mediaType='image'
                                medias={medias}
                                isPopinOpen={isPopinOpen}
                                onClose={() => setIsPopinOpen(false)}>
                                {credits}
                            </Dialog>
                        </>
                    )}
                </div>
                {hasCaption && (
                    <figcaption className="quiz-figure__caption">
                        {caption.map((line, index) => (
                            <div style={{'--i': index}} key={'c' + index}>{line}</div>
                        ))}
                    </figcaption>
                )}
            </figure>
    } else if(mediaType === 'video') {
        content =
            <figure className={outerContainerClasses}>
                <div className={mediaContainerClasses}>
                    <video ref={videoRef} autoPlay loop muted playsInline className="quiz-figure__media-video">
                        <source src={medias.mp4} type="video/mp4" />
                        <source src={medias.webm} type="video/webm" />
                    </video>
                    {hasCreditsPopin && (
                        <>
                            <ul className="buttons-list">
                                <li>
                                    <button
                                        className={(isPlaying) ? "button button--video-state button--pause" : "button button--video-state button--play"}
                                        onClick={() => setIsPlaying(!isPlaying)}
                                        aria-label={(isPlaying) ? "mettre en pause la vidéo" : "reprendre la lecture de la vidéo"}>
                                        {(isPlaying) ? <Icons type="pause" /> : <Icons type="play" />}
                                    </button>
                                </li>
                                <li>
                                    <button className="button button--legend" aria-label="afficher la légende de l'image" onClick={() => setIsPopinOpen(true)}>
                                        <svg role="img" xmlns="http://www.w3.org/2000/svg" width="32" height="32" version="1.1" viewBox="0 0 32 32">
                                            <title>afficher la légende de l&apos;image</title>
                                            <circle cx="16" cy="16" r="15.12" />
                                            <path d="M17.26,10.37c0,.7-.53,1.22-1.27,1.22s-1.25-.51-1.25-1.22.55-1.18,1.25-1.18,1.27.49,1.27,1.18ZM15.03,13.39h1.93v9.42h-1.93s0-9.42,0-9.42Z"/>
                                        </svg>
                                    </button>
                                </li>
                            </ul>
                            <Dialog
                                mediaType='image'
                                medias={medias}
                                isPopinOpen={isPopinOpen}
                                onClose={() => setIsPopinOpen(false)}>
                                {credits}
                            </Dialog>
                        </>
                    )}
                </div>
                {hasCaption && (
                    <figcaption className="quiz-figure__caption">
                        {caption.map((line, index) => (
                            <div style={{'--i': index}} key={'c' + index}>{line}</div>
                        ))}
                    </figcaption>
                )}
            </figure>
    }

    return content;
}

Figure.propTypes = {
    className: PropTypes.string,
    mediaContainerClassName: PropTypes.string,
    mediaType: PropTypes.string.isRequired,
    medias: PropTypes.object.isRequired,
    hasCreditsPopin: PropTypes.bool.isRequired,
    credits: PropTypes.element,
    hasCaption: PropTypes.bool.isRequired,
    caption: PropTypes.element,
    mediaAlt: PropTypes.string
}

export default Figure;
